import LogoutIcon from '@mui/icons-material/Logout';
import { Box, Grid, Typography } from '@mui/material';

import { MetaTags } from '@redwoodjs/web';

import Button from 'src/components/Button';
import MainCard from 'src/components/MainCard/MainCard';
import { useAuthContext } from 'src/contexts/AuthProvider';
import { PageContent } from 'src/layouts/MainLayout/PageContent';

import ChangePassword from './ChangePassword';
import MyDetails from './MyDetails';

const ProfilePage = () => {
    const { logout, user } = useAuthContext();

    return (
        <PageContent>
            <MetaTags title="Profile" description="Profile page" />

            <MainCard>
                <Typography variant="h4" color="grey.800" gutterBottom>
                    My Profile
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <MyDetails />
                        <Box display={'flex'} justifyContent={'space-between'}>
                            <Button
                                label="Logout"
                                sx={{ mt: 4, mb: 2 }}
                                onClick={logout}
                                startIcon={<LogoutIcon />}
                                variant="outlined"
                                color="primary"
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <ChangePassword />
                    </Grid>
                </Grid>
            </MainCard>
        </PageContent>
    );
};

export default ProfilePage;
